module.exports = __webpack_public_path__ + "img/image74.382bcb10.png";